var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.676 22a9 9 0 0 1-1.95-.22 13 13 0 0 1-2.008-.63 17.05 17.05 0 0 1 2.052-6.63 20.2 20.2 0 0 1 4.37-5.427 18.5 18.5 0 0 0-5.587 4.341 15.3 15.3 0 0 0-3.298 6.16 2 2 0 0 1-.22-.19l-.22-.22a9.6 9.6 0 0 1-2.097-3.08A9 9 0 0 1 2 12.554q0-1.994.792-3.813A10.4 10.4 0 0 1 4.99 5.514q2.052-2.055 5.087-2.875 3.034-.821 8.196-.587.762.03 1.407.337.645.309 1.143.807.5.5.792 1.159.294.66.352 1.423.176 5.28-.616 8.243-.791 2.962-2.815 4.987a10.4 10.4 0 0 1-3.21 2.215 9 9 0 0 1-3.65.777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEco);
export default __webpack_public_path__ + "static/media/eco.136dd9878fcdb37493d4afa645b56d70.svg";
export { ForwardRef as ReactComponent };